export enum RegistrationFeature {
  AccordionCustomContent = 'accordionCustomContent',
  ApplianceDetailsSteppedForm = 'applianceDetailsSteppedForm',
  ApplianceSpecificContent = 'applianceSpecificContent',
  AnnualPlans = 'annualPlans',
  CanRemoveApplianceRegistration = 'canRemoveApplianceRegistration',
  ExtraYearsWarrantyMessage = 'extraYearsWarrantyMessage',
  MaintenanceEnabled = 'maintenanceEnabled',
  PrivacyPolicyCheckbox = 'privacyPolicyCheckbox',
  ProtectionUpsellCheckbox = 'protectionUpsellCheckbox',
  ProtectionUpsellPage = 'protectionUpsellPage',
  RegistrationConfirmationPage = 'registrationConfirmationPage',
  SendRegistriaOrderInfo = 'sendRegistriaOrderInfo',
  SeoNoIndexMetaTag = 'seoNoIndexMetaTag',
  WibEnabled = 'wibEnabled',
}
